import React from 'react';
import Icon from '../../../components/AppIcon';

const OperationalMetricsPanel = ({ metrics }) => {
  const calculateOverallEfficiency = () => {
    const utilizationScore = parseFloat(metrics?.utilizationRate) || 0;
    const qualityScore = 100 - (parseFloat(metrics?.rejectionRate) || 0);
    const lossScore = 100 - (parseFloat(metrics?.productionLoss) || 0);
    const bufferScore = parseFloat(metrics?.resilienceScore) || 0;
    
    return ((utilizationScore + qualityScore + lossScore + bufferScore) / 4)?.toFixed(1);
  };

  const getEfficiencyStatus = (score) => {
    if (score >= 85) return { label: 'Excellent', color: 'text-success', bg: 'bg-success/10' };
    if (score >= 70) return { label: 'Good', color: 'text-primary', bg: 'bg-primary/10' };
    if (score >= 50) return { label: 'Fair', color: 'text-warning', bg: 'bg-warning/10' };
    return { label: 'Poor', color: 'text-error', bg: 'bg-error/10' };
  };

  const overallScore = calculateOverallEfficiency();
  const status = getEfficiencyStatus(overallScore);

  const metricsData = [
    {
      label: 'Utilisasi Kapasitas',
      value: `${metrics?.utilizationRate || 0}%`,
      icon: 'Gauge',
      color: 'text-primary',
      bg: 'bg-primary/10'
    },
    {
      label: 'Tingkat Penolakan',
      value: `${metrics?.rejectionRate || 0}%`,
      icon: 'XCircle',
      color: 'text-error',
      bg: 'bg-error/10'
    },
    {
      label: 'Production Loss',
      value: `${metrics?.productionLoss || 0}%`,
      icon: 'TrendingDown',
      color: 'text-warning',
      bg: 'bg-warning/10'
    },
    {
      label: 'Buffer Days',
      value: `${metrics?.bufferDays || 0}`,
      icon: 'Calendar',
      color: 'text-success',
      bg: 'bg-success/10'
    },
    {
      label: 'Bottleneck Kritis',
      value: `${metrics?.criticalBottlenecks || 0}`,
      icon: 'AlertTriangle',
      color: 'text-destructive',
      bg: 'bg-destructive/10'
    },
    {
      label: 'Staff Produksi',
      value: `${metrics?.productionStaff || 0}`,
      icon: 'Users',
      color: 'text-accent',
      bg: 'bg-accent/10'
    }
  ];

  return (
    <div className="card space-y-6">
      <div className="flex items-center gap-3 pb-4 border-b border-border">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="BarChart3" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-semibold">Metrik Operasional Real-time</h2>
          <p className="text-sm text-muted-foreground">Dashboard performa operasional terkini</p>
        </div>
      </div>
      <div className={`p-6 rounded-xl ${status?.bg} border border-${status?.color?.replace('text-', '')}/20`}>
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Skor Efisiensi Keseluruhan</p>
            <p className={`text-5xl font-bold ${status?.color} data-text`}>{overallScore}</p>
          </div>
          <div className="text-right">
            <span className={`inline-block px-4 py-2 rounded-lg text-sm font-medium ${status?.bg} ${status?.color}`}>
              {status?.label}
            </span>
          </div>
        </div>
        <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className={`h-full ${status?.color?.replace('text-', 'bg-')} transition-all duration-500`}
            style={{ width: `${overallScore}%` }}
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {metricsData?.map((metric, index) => (
          <div key={index} className={`p-4 rounded-lg ${metric?.bg} border border-${metric?.color?.replace('text-', '')}/20`}>
            <div className="flex items-center justify-between mb-2">
              <p className="text-sm text-muted-foreground">{metric?.label}</p>
              <Icon name={metric?.icon} size={20} color={`var(--color-${metric?.color?.replace('text-', '')})`} />
            </div>
            <p className={`text-2xl font-bold ${metric?.color} data-text`}>{metric?.value}</p>
          </div>
        ))}
      </div>
      <div className="p-4 rounded-lg bg-muted">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium">Tentang Metrik Ini</p>
            <p className="text-xs text-muted-foreground mt-1">
              Metrik operasional diperbarui secara real-time berdasarkan data yang Anda masukkan. Skor efisiensi keseluruhan dihitung dari rata-rata utilisasi kapasitas, kualitas produk, minimalisasi loss, dan resiliensi buffer.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationalMetricsPanel;